import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AutocompleteItem } from './autocomplete-item';

@Component({
  selector: 'vectronic-autocomplete',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatBadgeModule,
  ],
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent {
  placeholder = input(''); // A text that is shown as a placeholder in the input-field of the autocomplete
  autocompleteItems = input<AutocompleteItem[]>();
  loading = input<boolean>();
  width = input<'standard' | 'wide' | 'full'>();
  hideSearchButton = input(false);
  control = input.required<FormControl<string>>();
  itemSelected = output<any>();

  showSearch = true;

  getAutocompleteItemValue(item: string) {
    return this.autocompleteItems()?.find((i) => i.value === item)?.label || item;
  }
}
